<template>
  <div class="d-flex align-items-center flex-wrap">
    <bs-button class="btn-sm btn-warning ml-2" @click="$router.push({ path: '/vehicle/' + vehicle })">{{ $t('labels.overview') }}</bs-button>
    <bs-button class="btn-sm btn-warning ml-2" @click="$router.push({ path: '/vehicle/' + vehicle + '/tracking' })">{{ $t('labels.tracking') }}</bs-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'NavSecondaryVehicle',
  props: ['vehicle'],
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  }
}
</script>
